import { render, staticRenderFns } from "./TableItem2.vue?vue&type=template&id=187c1a3c&scoped=true"
import script from "./TableItem2.vue?vue&type=script&lang=js"
export * from "./TableItem2.vue?vue&type=script&lang=js"
import style0 from "./TableItem2.vue?vue&type=style&index=0&id=187c1a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c1a3c",
  null
  
)

export default component.exports